import type { Nil } from '@pbt/pbt-ui-components'

export const getInactiveItemsErrorMessage = (
  estimateBundleHasInactiveItemsError: boolean,
  hasInactiveItemsError: boolean,
  t: (key: string) => string,
) => {
  if (estimateBundleHasInactiveItemsError) {
    return t('Soap:ESTIMATE.BUNDLE_INACTIVE_ITEMS')
  }
  if (hasInactiveItemsError) {
    return t('Soap:ESTIMATE.WOULD_YOU_LIKE_TO_CONTINUE')
  }
  return t('Soap:ESTIMATE.ESTIMATE_CAN_NOT_BE_CLONED')
}

export const getIsAllowedFromTimeline = (
  fromTimeline: boolean,
  timelineEstimateId: string | Nil,
  attachingToSoapEstimateId: string | null,
  soapToAttachEstimateId: string | null,
) =>
  fromTimeline &&
  timelineEstimateId === attachingToSoapEstimateId &&
  soapToAttachEstimateId

export const getIsAllowedFromSoap = (
  fromSoap: boolean,
  cloningEstimateId: string | null,
  attachingToSoapEstimateId: string | null,
  soapToAttachEstimateId: string | null,
) =>
  fromSoap &&
  (cloningEstimateId || attachingToSoapEstimateId) &&
  !soapToAttachEstimateId
